// extracted by mini-css-extract-plugin
module.exports = {"dialog":"BrMsx9vYV60hUoGqjcJNS"};